import { useSelector } from 'react-redux';
import { RootState } from '@/shared/redux/reducers';

const userCan = (allowedRoles: string[]) => {
  const userRole = useSelector((state: RootState) => state.auth.role) ?? [];

  return userRole.some((role) => allowedRoles.includes(role));
};

export default userCan;
